import theme from "themes/default";
import themeLowi from "themes/lowi";
import themeCZ from "themes/cz";

export function getActiveTheme(opco: string) {
  if (opco === "lw") {
    return themeLowi;
  } else if (opco === "cz" || opco === "tr") {
    return themeCZ;
  } else {
    return theme; // default theme
  }
}
